import { createApp } from 'vue'

import App from '@/App.vue'
import router from '@/router'
import { VueQueryPlugin, vueQueryOptions } from '@/lib/query'
import { installNavigationLoading } from '@/composables/useNavigationLoading'

import 'vue-sonner/style.css'
import '@/assets/css/tailwind.css'

installNavigationLoading(router)

createApp(App).use(router).use(VueQueryPlugin, vueQueryOptions).mount('#app')
